import React from 'react';
import { HeroVariant3 } from '../components/HeroVariant3';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage3() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1573">
      <Navigation data-id="element-1574" />
      <main data-id="element-1575">
        <HeroVariant3 data-id="element-1576" />
        <WhyUs data-id="element-1577" />
        <Services data-id="element-1578" />
        <FAQ data-id="element-1579" />
        <Testimonials data-id="element-1580" />
        <Consultation data-id="element-1581" />
      </main>
      <Footer data-id="element-1582" />
      <CookieBanner data-id="element-1583" />
      <FloatingContact data-id="element-1584" />
    </div>;
}